import React from 'react';

export const exercisesLabel = (n) => {
  const tens = n % 100;
  const last = n % 10;
  if (n === 1) return '1 ćwiczenie';
  return `${n} ${last >= 2 && last <= 4 && (tens < 12 || tens > 14) ? 'ćwiczenia' : 'ćwiczeń'}`;
};

// Every training of the week stays visible with its full name: no sideways scrolling.
// days = [{ day, label, count }]; label is optional.
export const DaySelector = ({ days, selected, onSelect }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2.5 mb-8" data-testid="day-selector">
    {days.map(({ day, label, count }) => (
      <button
        key={day}
        onClick={() => onSelect(day)}
        aria-pressed={selected === day}
        className={`flex items-center gap-3 px-4 py-3 rounded-2xl border transition-all text-left ${
          selected === day
            ? 'bg-[#1E1E1E] border-[#C9A84C] text-white'
            : 'bg-[#0A0A0A] border-[#2A2A2A] text-[#A1A1A1] hover:border-[#C9A84C]/50'
        }`}
        data-testid={`day-${day}`}
      >
        <span className={`w-8 h-8 shrink-0 rounded-full flex items-center justify-center text-sm font-bold ${
          selected === day ? 'bg-[#C9A84C] text-[#0A0A0A]' : 'bg-[#2A2A2A] text-[#A1A1A1]'
        }`}>
          {day}
        </span>
        <span className="min-w-0">
          <span className="block text-sm font-semibold leading-snug">{label || `Trening ${day}`}</span>
          <span className="block text-xs text-[#A1A1A1] mt-0.5">{exercisesLabel(count)}</span>
        </span>
      </button>
    ))}
  </div>
);
